module.exports = __webpack_public_path__ + "img/klarna-alt.8a56d7a9.png";